import React from 'react';
import PropTypes from 'prop-types';
import {
  mediaUploadAccept,
  mediaUploadLabel,
  mediaVideoAccept,
  mediaVideoLabel,
  uniqueFileNames
} from '../../constants/files';
import { trimLowerCase } from '../../helpers/shared';
import { getShowField } from '../../helpers/base';
import { AuxInput } from '../tier/input/AuxInput';
import { DateInput } from '../tier/input/DateInput'
import { FileInputButton } from '../tier/input/FileInputButton'
import { SignatureInput } from '../tier/input/SignatureInput'
import { TextInput } from '../tier/input/TextInput'
import { Select } from '../tier/select/Select';
import { AutocompleteTypeahead } from '../tier/select/AutocompleteTypeahead';
import { ImageSelect } from '../tier/select/ImageSelect';
import { CheckboxSelect } from '../tier/select/CheckboxSelect';
import { VideoMessage } from '../tier/VideoMessage';
import { useParams } from 'react-router-dom';
import { useFields } from '../../hooks/useFields';
import VideoInputRTC from '../tier/autovideoRTC/VideoInputRTC';

/**
 * Component with fields for Files
 * @component
 * @param {Object} fields
 * @returns
 */
export const Fields = ({ fields, files }) => {
  const { codeTier } = useParams() 
  const { advancedFields } = useFields(codeTier)

  return (
    <>
      {fields.map(item => {
        let isShown = getShowField(item.data)
        if (item.data) {
          if (item.data.active && isShown) {
            let fileFields = files.filter(file => {
              /* let fileName = file?.field_request?.unique_name
              let itemGroup = item.data.unique_name.split('__')[0]
              return fileName?.includes(itemGroup) */
              let fileField = advancedFields?.filter(field => field?.id === file?.field_request?.id)[0]
              let coincidenceFile = fileField?.category?.field_category === item?.field_category;
              if (!coincidenceFile) {
                // Compare again but remove the '_ibv' portion
                let fileName = file?.field_request?.unique_name
                let itemGroup = item.data.unique_name.split('__')[0]
                if (fileName?.endsWith('_ibv')) {
                  fileName = fileName.slice(0, -4)
                }
                coincidenceFile = fileName?.includes(itemGroup)
              }
              return coincidenceFile
            })
            let file = files.filter(file => file.field_request.unique_name === item.data.unique_name)[0]
            if (!file){
              // Compare again but remove the '_ibv' portion
              file = files.filter(file => {
                let fileName = file?.field_request?.unique_name
                let itemName = item.data.unique_name
                if (fileName?.endsWith('_ibv')) {
                  fileName = fileName.slice(0, -4)
                }
                return fileName === itemName
              })[0]
            }
            let isFileUploadable = false
            let isGroup = false
            if (fileFields) {
              isFileUploadable = file?.user_file_status?.unique_description === codeTier
              isGroup = fileFields?.some(file => {
                return file.user_file_status.unique_description === codeTier
              }) 
            }
            if (trimLowerCase(item.data.data_type) === 'text' ||
              trimLowerCase(item.data.data_type) === 'number' ||
              trimLowerCase(item.data.data_type) === 'textarea') {
              return (
                <TextInput
                  field={item.data}
                  key={item.data.id}
                  isGroup={isGroup}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'image_selection') {
              return (
                <ImageSelect
                  field={item.data}
                  key={item.data.id}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'checkbox_selection' ||
              trimLowerCase(item.data.data_type) === 'media_selection') {
              return (
                <CheckboxSelect
                  field={item.data}
                  key={item.data.id}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'date') {
              return (
                <DateInput
                  field={item.data}
                  key={item.data.id}
                  isGroup={isGroup}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'selection' && !JSON.parse(item.data?.action)?.isBlock) {
              if (item.data?.action && JSON.parse(item.data?.action).isTypeahead) {
                return (
                  <AutocompleteTypeahead
                    field={ item.data }
                    key={ item.data.id }
                    isGroup={ isGroup}
                  />
                );
              }
              return (
                <Select
                  field={ item.data }
                  key={ item.data.id }
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'message') {
              return (
                <VideoMessage
                  field={item.data}
                  key={item.data.id}
                  isGroup={ isGroup }
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'media_video') {
              return (
                <VideoInputRTC 
                  field={item.data}
                  accept={ mediaVideoAccept }
                  formatAccept={mediaVideoLabel}
                  type='video'
                  key={item.data.id}
                  isFileUploadable={isFileUploadable}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'media_upload') {
              return (
                <FileInputButton
                  accept={mediaUploadAccept}
                  formatAccept={mediaUploadLabel}
                  field={item.data}
                  key={item.data.id}
                  type={(item.data.unique_name === uniqueFileNames[item.data.file_name])
                    ? "document"
                    : "image"}
                  isFileUploadable={isFileUploadable}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'media_signature') {
              return (
                <SignatureInput
                  field={item.data}
                  isFileUploadable={isFileUploadable}
                  key={item.data.id}
                />
              );
            }
            if (trimLowerCase(item.data.data_type) === 'aux') {
              return (
                <AuxInput
                  field={item.data}
                  key={item.data.id}
                />
              );
            }
          }
        }
        return null;
      })}
    </>
  );
};

Fields.propTypes = {
  fields: PropTypes.array.isRequired,
};